"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Ratings = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _Button = _interopRequireDefault(require("../Button"));
var _ErrorMessage = _interopRequireDefault(require("../ErrorMessage"));
var _Hint = _interopRequireDefault(require("../Hint"));
var _Label = _interopRequireDefault(require("../Label"));
var _Ratings = require("./Ratings.style");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const Ratings = exports.Ratings = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      className = 'ratings',
      disabled,
      error,
      fillColor,
      fillIcon = 'star-solid',
      fit = 'medium',
      hint,
      label,
      name = 'rating',
      prefix,
      readOnly,
      required = false,
      scale = 5,
      strokeColor = '',
      strokeIcon = 'star',
      suffix,
      variant = 'default',
      value = 0,
      width,
      onChange
    } = props,
    rest = __rest(props, ["className", "disabled", "error", "fillColor", "fillIcon", "fit", "hint", "label", "name", "prefix", "readOnly", "required", "scale", "strokeColor", "strokeIcon", "suffix", "variant", "value", "width", "onChange"]);
  const [rating, setRating] = (0, _react.useState)(value);
  const ratingButtons = [];
  const onRatingClick = (idx, e) => {
    let value;
    if (!isNaN(idx)) {
      // allow user to click first icon and set rating to zero if rating is already 1
      if (rating === 1 && idx === 1) {
        setRating(0);
        value = 0;
      } else {
        value = idx;
        setRating(idx);
      }
      typeof onChange === 'function' && onChange(e, value);
    }
  };
  const RatingButton = _ref => {
    let {
      idx,
      fill
    } = _ref;
    return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: typeof strokeIcon !== 'object' ? (0, _jsxRuntime.jsx)(_Button["default"], (0, _extends2["default"])({}, rest, {
        disabled: disabled,
        id: "".concat(idx),
        variant: "plain",
        appearance: "default",
        className: fill ? 'active' : '',
        fit: fit,
        icon: fill ? fillIcon : strokeIcon,
        onClick: e => onRatingClick(idx, e)
      })) : (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: (0, _jsxRuntime.jsx)("button", (0, _extends2["default"])({}, rest, {
          disabled: disabled,
          id: "".concat(idx),
          className: fill ? 'active' : '',
          onClick: e => onRatingClick(idx, e)
        }, {
          children: fill ? (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
            children: fillIcon
          }) : (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
            children: strokeIcon
          })
        }))
      })
    });
  };
  for (let i = 1; i <= scale; i++) {
    ratingButtons.push((0, _jsxRuntime.jsx)(RatingButton, {
      idx: i,
      fill: i <= rating
    }, i));
  }
  return (0, _jsxRuntime.jsxs)(_Ratings.Components.Wrapper, (0, _extends2["default"])({
    className: "wrapper-".concat(className),
    variant: variant,
    fillColor: fillColor,
    strokeColor: strokeColor,
    width: width,
    ref: ref
  }, {
    children: [label && (0, _jsxRuntime.jsx)(_Label["default"], (0, _extends2["default"])({
      label: label,
      required: required,
      fit: fit,
      className: className
    }, rest)), (0, _jsxRuntime.jsx)("input", {
      name: name,
      type: "hidden",
      value: value
    }), (0, _jsxRuntime.jsxs)(_Ratings.Components.Area, {
      children: [prefix && (0, _jsxRuntime.jsx)(_Ratings.Components.Prefix, (0, _extends2["default"])({
        fit: fit
      }, {
        children: prefix === null || prefix === void 0 ? void 0 : prefix.slice(0, 3)
      })), (0, _jsxRuntime.jsx)(_Ratings.Components.ButtonWrapper, (0, _extends2["default"])({
        prefix: prefix,
        suffix: suffix
      }, {
        children: ratingButtons
      })), suffix && (0, _jsxRuntime.jsx)(_Ratings.Components.Suffix, (0, _extends2["default"])({
        fit: fit
      }, {
        children: suffix === null || suffix === void 0 ? void 0 : suffix.slice(0, 3)
      }))]
    }), error && (0, _jsxRuntime.jsx)(_ErrorMessage["default"], (0, _extends2["default"])({
      fit: fit
    }, rest)), hint && (0, _jsxRuntime.jsx)(_Hint["default"], (0, _extends2["default"])({
      hint: hint,
      fit: fit
    }, rest))]
  }));
});
var _default = exports["default"] = Ratings;